import * as React from 'react'
import '../css/steps.css'

interface Block {
    title?: string
    textList?: string[]
    img?: string
}

interface StepsProps {
    blocks: Block[]
}

const Steps = (props: StepsProps) => {

    const renderBlock = (block: Block, i) => (
        <div key={'step-' + i} className={(i % 2) == 0 ? 'steps-block-reverse' : 'steps-block'}>
            <div className="steps-block-left">
                <div className="absolute-image">
                    <p className="steps-text">{block.title}</p>
                    <div className="steps-index">
                        <img src={'https://static.persona.ly/images/monetization/' + i + '.svg'}/>
                    </div>
                    <div className="steps-image">
                        <img src={block.img}/>
                    </div>
                    <img className="hexagon-2 not-mobile" src="https://static.persona.ly/images/polygon-14.svg"/>
                </div>
            </div>
            <div className="steps-block-right">
                <img className="hexagon-1" src="https://static.persona.ly/images/polygon.svg"/>
                <img className="hexagon-2 not-tablet not-desktop" src="https://static.persona.ly/images/polygon-14.svg"/>
                <div className="text-container">
                    {block.textList && block.textList.map((text, i) => <p key={i}>{text}</p>)}
                </div>
            </div>
        </div>
    )

    const renderList = () => props.blocks.map((block: any, index) => renderBlock(block, index + 1))

    return <div className="steps-container">{renderList()}</div>
}

export default Steps


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/steps.tsx